/**
 * plantillas.js — lectura del payload de `GET /plantillas`.
 *
 * `c_getPlantillas` responde `{ ...primeraPáginaDeMeta, data: [...] }`, es decir
 * el array vive en `.data` — NUNCA en `.plantillas`. Varios callers leían solo
 * `res?.plantillas` y se quedaban con `[]`: al no encontrar la plantilla mandaban
 * `templateData: undefined` a `/send-template`, y c_sendTemplate construía una
 * plantilla mínima con body `"{{1}} {{2}}"`. El envío a Meta sale bien (Meta
 * renderiza por nombre), pero el CRM guarda y pinta el mensaje como la mera
 * concatenación de los parámetros (incidente BLUECAR, 2026-08-19: el chat mostraba
 * "639481078  Contraseña: 639481078 app.conextcrm.es" en vez del cuerpo aprobado).
 */

/** Devuelve siempre un array con las plantillas del payload de `/plantillas`. */
export function extractPlantillas(res) {
  if (Array.isArray(res)) return res;
  if (Array.isArray(res?.data)) return res.data;
  if (Array.isArray(res?.plantillas)) return res.plantillas;
  if (Array.isArray(res?.data?.data)) return res.data.data;
  return [];
}

/** Localiza una plantilla por su nombre exacto; `null` si no está. */
export function findPlantillaByName(res, name) {
  if (!name) return null;
  return extractPlantillas(res).find((t) => t?.name === name) || null;
}
